interface FlashpointEnv {
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
  };
  orchestratorUrl: string;
  /** From `ORCHESTRATOR_BEARER_TOKEN` via Vite define unless `VITE_ORCHESTRATOR_BEARER_TOKEN` is set. */
  orchestratorBearerToken: string;
}

function required(value: string | undefined, key: string): string {
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${key}. ` +
        `Copy .env.example to .env.local in the repo root and fill in the value.`,
    );
  }
  return value;
}

export const env: FlashpointEnv = {
  firebase: {
    apiKey: required(import.meta.env.VITE_FIREBASE_API_KEY, 'VITE_FIREBASE_API_KEY'),
    authDomain: required(import.meta.env.VITE_FIREBASE_AUTH_DOMAIN, 'VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: required(import.meta.env.VITE_FIREBASE_PROJECT_ID, 'VITE_FIREBASE_PROJECT_ID'),
    storageBucket: required(
      import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      'VITE_FIREBASE_STORAGE_BUCKET',
    ),
    messagingSenderId: required(
      import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      'VITE_FIREBASE_MESSAGING_SENDER_ID',
    ),
    appId: required(import.meta.env.VITE_FIREBASE_APP_ID, 'VITE_FIREBASE_APP_ID'),
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  },
  orchestratorUrl: import.meta.env.VITE_ORCHESTRATOR_URL ?? 'http://localhost:8787',
  /**
   * Set in repo-root .env as ORCHESTRATOR_BEARER_TOKEN; Vite may inject the same
   * value for the dashboard (see flashpoint-app/vite.config.ts).
   */
  orchestratorBearerToken: import.meta.env.VITE_ORCHESTRATOR_BEARER_TOKEN ?? '',
};
